import * as React from "react";
import { createPortal } from "react-dom";

export type ModalShellProps = React.PropsWithChildren<{
  open: boolean;
  onClose?: () => void;
  disableBackdropClose?: boolean;
  contentClassName?: string;
}>;

export function ModalShell({
  open,
  onClose,
  disableBackdropClose = false,
  children,
  contentClassName = "",
}: ModalShellProps) {
  if (!open) return null;

  const handleOverlayClick = () => {
    if (!disableBackdropClose) {
      onClose?.();
    }
  };

  const modalContent = (
    <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute top-0 left-0 right-0 bottom-0 bg-black/60" onClick={handleOverlayClick} />
      <div
        role="dialog"
        aria-modal="true"
        className={`relative z-[101] w-full max-w-md ${contentClassName}`}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
